import { apiCall } from 'core/api/apiService';

export const loadProducts = async (shopId, user) => {
  const response = await apiCall(`/admin/internal-shops/${shopId}/products`, 'GET', null, user);
  return response || [];
};

// Laedt ein einzelnes Produkt vollstaendig (inkl. sources/stock/texts/order_history).
// Wird im Edit-Pfad genutzt, damit die ProductForm alle Detailfelder bekommt.
export const loadProduct = async (shopId, id, user) => {
  const response = await apiCall(`/admin/internal-shops/${shopId}/products/${id}`, 'GET', null, user);
  return response || null;
};

export const loadCategories = async (shopId, user) => {
  const response = await apiCall(`/internal-shops/${shopId}/categories`, 'GET', null, user);
  return response || [];
};

export const saveProduct = async (shopId, productData, editingProduct, user) => {
  const method = editingProduct ? 'PUT' : 'POST';
  const endpoint = editingProduct 
    ? `/admin/internal-shops/${shopId}/products/${editingProduct.id}` 
    : `/admin/internal-shops/${shopId}/products`;
  
  return await apiCall(endpoint, method, productData, user);
};

export const deleteProduct = async (shopId, productId, user) => {
  return await apiCall(`/admin/internal-shops/${shopId}/products/${productId}`, 'DELETE', null, user);
};